import { render, staticRenderFns } from "./InviteOrEdit.vue?vue&type=template&id=0abf8044&scoped=true"
import script from "./InviteOrEdit.vue?vue&type=script&lang=js"
export * from "./InviteOrEdit.vue?vue&type=script&lang=js"
import style0 from "./InviteOrEdit.vue?vue&type=style&index=0&id=0abf8044&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abf8044",
  null
  
)

export default component.exports